// =========================================================
// BLOG HELPERS
// =========================================================

// =========================================================
// GENERATE BLOG SLUG
// =========================================================

export const generateBlogSlug = (title) => {
  if (!title) {
    return "";
  }

  return title
    .toString()
    .toLowerCase()
    .trim()
    .replace(/[^\w\s-]/g, "")
    .replace(/\s+/g, "-")
    .replace(/-+/g, "-");
};

// =========================================================
// CREATE BLOG SLUG
// Alias kept for compatibility
// =========================================================

export const createBlogSlug = (title) => {
  return generateBlogSlug(title);
};

// =========================================================
// TAGS → STRING
// =========================================================

export const tagsToString = (tags) => {
  if (!tags) {
    return "";
  }

  if (Array.isArray(tags)) {
    return tags.join(", ");
  }

  return tags.toString();
};

// =========================================================
// STRING → TAGS
// =========================================================

export const stringToTags = (tags) => {
  if (!tags) {
    return [];
  }

  if (Array.isArray(tags)) {
    return tags;
  }

  return tags
    .split(",")
    .map((tag) => tag.trim())
    .filter((tag) => tag.length > 0);
};

// =========================================================
// FORMAT BLOG DATE
// =========================================================

export const formatBlogDate = (date) => {
  if (!date) {
    return "No date";
  }

  try {
    // Firebase Timestamp
    if (date?.toDate) {
      return date.toDate().toLocaleDateString("en-IN", {
        day: "numeric",
        month: "long",
        year: "numeric",
      });
    }

    // JavaScript Date
    if (date instanceof Date) {
      return date.toLocaleDateString("en-IN", {
        day: "numeric",
        month: "long",
        year: "numeric",
      });
    }

    // String / Number
    const parsedDate = new Date(date);

    if (isNaN(parsedDate.getTime())) {
      return "No date";
    }

    return parsedDate.toLocaleDateString("en-IN", {
      day: "numeric",
      month: "long",
      year: "numeric",
    });
  } catch (error) {
    console.error("Blog date formatting error:", error);

    return "No date";
  }
};
